/**
* Hreflang helpers for the /moj/* cluster. Thai canonical is x-default;
* 6 locale mirrors advertised so Google consolidates ranking signals.
*/
const BASE = "https://thainotarylaw.com";
const LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

export const MOJ_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/moj` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/moj` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/moj` },
];

export function mojServiceHreflangLinks(slug: string) {
  const p = (loc?: string) => loc ? `/${loc}/moj/services/${slug}` : `/moj/services/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${p()}` },
    ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}${p(l)}` })),
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${p()}` },
  ];
}
